import { makeStyles } from '@mui/styles'
import { display, Theme } from '@mui/system'
import { FONTS, SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  inviteModalWrapper: {
    '&&': {
      height: 300,

      padding: SPACES.xxxxl,

      [theme.breakpoints.down('tablet')]: {
        maxWidth: 'calc(100vw - 32px)',
        minWidth: 300,
      },
      [theme.breakpoints.up('tablet')]: {
        width: 400,
      },
    },
  },
  changeUserRoleModalWrapper: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',

      padding: '32px 24px',

      [theme.breakpoints.down('tablet')]: {
        maxWidth: 'calc(100vw - 32px)',
        minWidth: 300,
      },
      [theme.breakpoints.up('tablet')]: {
        width: 400,
      },
    },
  },
  inviteForm: {
    width: '100%',
    height: '100%',

    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',

    gap: SPACES.xxxxxl,
  },
  formInputsWrapper: {
    width: '100%',

    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.xxl,
  },
  inviteModalTitle: {
    '&&': {
      fontSize: '18px',
      fontWeight: FONTS.WEIGHTS.bold,
      color: theme.palette.custom.darkBlue2,
    },
  },

  tableIcon: {
    '&&': {
      marginLeft: 2,
      marginRight: 2,
    },
  },
  tableRow: {
    '&&': {
      borderTop: `1px solid ${theme.palette.custom.grey}`,
      borderBottom: `1px solid ${theme.palette.custom.grey}`,
    },
  },

  inviteButton: {
    '&&': {
      display: 'flex',
      marginTop: SPACES.xxxxxl,
      marginBottom: SPACES.xxxxxl,

      [theme.breakpoints.down('tablet')]: {
        marginLeft: 'auto',
        marginRight: 'auto',
      },
      [theme.breakpoints.up('tablet')]: {
        marginLeft: '135px',
      },
    },
  },

  userStatus: {
    '&&': {
      '&:first-letter': {
        textTransform: 'uppercase',
      },
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: '12px',
      lineHeight: 1.33,

      "&[data-status='active']": {
        color: theme.palette.custom.primary,
      },
      "&[data-status='pending']": {
        color: theme.palette.custom.suppressing,
      },
      "&[data-status='deactivated']": {
        color: theme.palette.custom.grey2,
      },
    },
  },
  userDate: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.light,
      fontSize: '12px',
      lineHeight: 1.33,
      color: theme.palette.custom.darkBlue2,
    },
  },
  selectionWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: 98,
    paddingLeft: 8,
    marginLeft: 'auto',
    marginRight: 'auto',
    justifyContent: 'center',
    alignItems: 'center',
  },
}))

export { useStyles }
